import React from "react";
import PastorReportDetail from "../pastors/pastor-report-detail/PastorReportDetail";
import IdleWrapper from "../components/auth/IdleWrapper";

export default function PastorDetailPage() {
  return <IdleWrapper> <PastorReportDetail /> </IdleWrapper>;
}
